import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints"; 
import {
  AuthService,
  buildParamString,
  IAPICommonResponse,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import {
  IAPIPaymentMethodModel,
  IAPIPaymentMethodReferenceInPurchases,
  IAPIPaymentMethodResponseModel,
} from "../interfaces/IAPIRelatedPaymentMethod";
import { IAPIGetPaymentMethodSummaryModel } from "../interfaces/IAPIPaymentMethodModels";
import {
  IAPICreatePaymentMethodModel,
  IAPIUpdatePaymentMethodModel,
} from "../interfaces/IAPIUpsertPaymentMethodModels";

class PaymentMethodService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  deletePaymentMethod(accountId: string, id: string) {
    const request = {
      id: id,
      accountId: accountId,
    };
    return this.httpService.delete<IAPIResponse<IAPICommonResponse>>(
      url.deletePaymentMethod,
      request
    );
  }

  getPaymentMethodReferenceInPurchases(
    accountId: string,
    paymentMethodId: string
  ): Observable<IAPIResponse<IAPIPaymentMethodReferenceInPurchases>> {
    const params: string = buildParamString({
      accountId: accountId,
      paymentMethodId: paymentMethodId,
    });

    return this.httpService.get<
      IAPIResponse<IAPIPaymentMethodReferenceInPurchases>
    >(url.getPaymentMethodReferenceInPurchases, params);
  }

  getPaymentMethods(): Observable<IAPIResponse<IAPIPaymentMethodModel[]>> {
    const params: string = buildParamString({
      accountId: AuthService.authData.accountId,
    });

    return this.httpService.get<IAPIResponse<IAPIPaymentMethodModel[]>>(
      url.getPaymentMethods,
      params
    );
  }

  getPaymentMethodSummary(
    contactId: string,
    paymentMethodId: string
  ): Observable<IAPIResponse<IAPIGetPaymentMethodSummaryModel>> {
    const params: string = buildParamString({
      contactId: contactId,
      paymentMethodId: paymentMethodId,
      accountId: AuthService.authData.accountId,
    });
    return this.httpService.get<IAPIResponse<IAPIGetPaymentMethodSummaryModel>>(
      url.getPaymentMethodSummary,
      params
    );
  }

  getPaymentMethod(
    paymentMethodId: string
  ): Observable<IAPIResponse<IAPIPaymentMethodModel>> {
    const params: string = buildParamString({
      paymentMethodId: paymentMethodId,
      accountId: AuthService.authData.accountId,
    });
    return this.httpService.get<IAPIResponse<IAPIPaymentMethodModel>>(
      url.getPaymentMethod,
      params
    );
  }

  createPaymentMethod(
    data: IAPICreatePaymentMethodModel
  ): Observable<IAPIResponse<IAPIPaymentMethodResponseModel>> {
    return this.httpService.post<IAPIResponse<IAPIPaymentMethodResponseModel>>(
      url.createPaymentMethod,
      data
    );
  }

  updatePriority(
    data: IAPIUpdatePaymentMethodModel
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.post<IAPIResponse<IAPICommonResponse>>(
      url.updatePriority,
      data
    );
  }
}
export default new PaymentMethodService();
